import React from "react";
import { motion } from "framer-motion";

const themeMap = {
  "bg-violet-500": {
    gradient: "from-violet-500 to-purple-600",
    light: "bg-violet-50",
    border: "border-violet-100",
    text: "text-violet-600",
    bar: "from-violet-500 to-purple-600",
  },
  "bg-blue-500": {
    gradient: "from-blue-500 to-blue-600",
    light: "bg-blue-50",
    border: "border-blue-100",
    text: "text-blue-600",
    bar: "from-blue-500 to-blue-600",
  },
  "bg-emerald-500": {
    gradient: "from-emerald-500 to-green-600",
    light: "bg-emerald-50",
    border: "border-emerald-100",
    text: "text-emerald-600",
    bar: "from-emerald-500 to-green-600",
  },
  "bg-amber-500": {
    gradient: "from-amber-400 to-orange-500",
    light: "bg-amber-50",
    border: "border-amber-100",
    text: "text-amber-600",
    bar: "from-amber-400 to-orange-500",
  },
  "bg-red-500": {
    gradient: "from-red-500 to-rose-600",
    light: "bg-red-50",
    border: "border-red-100",
    text: "text-red-600",
    bar: "from-red-500 to-rose-600",
  },
};

export default function StatCard({
  title,
  value,
  subValue,
  icon: Icon,
  iconColor = "bg-blue-500",
  trend,
  trendUp,
  delay = 0,
}) {
  const theme = themeMap[iconColor] || themeMap["bg-blue-500"];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
      className="relative overflow-hidden bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300 group h-full"
    >
      {/* Top accent bar */}
      <div className={`h-1 w-full bg-gradient-to-r ${theme.bar}`} />

      <div className="p-4 sm:p-5">
        {/* Icon + title row */}
        <div className="flex items-center gap-2.5 mb-3">
          <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${theme.gradient} flex items-center justify-center flex-shrink-0`}>
            <Icon className="h-4 w-4 text-white" />
          </div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 leading-none">{title}</p>
        </div>

        {/* Value */}
        <p className="text-base sm:text-lg font-bold text-slate-900 leading-none break-words">{value}</p>

        {subValue && <p className="text-xs sm:text-sm text-slate-400 mt-1 break-words">{subValue}</p>}

        {trend && (
          <div className={`inline-flex items-center gap-1 mt-2 px-1.5 py-0.5 rounded-full text-xs font-semibold ${trendUp ? "bg-emerald-50 text-emerald-600" : "bg-red-50 text-red-500"}`}>
            {trendUp ? "↑" : "↓"} {trend}
          </div>
        )}
      </div>
    </motion.div>
  );
}
